import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS } from 'src/constants'

interface IProps {
  color: 'primary' | 'dark' | 'light'
}

export const useStyles = makeStyles((theme: Theme) => ({
  button: (props: IProps) => ({
    '&&': {
      minHeight: 44,

      backgroundColor:
        props.color === 'primary'
          ? theme.palette.custom.primary
          : props.color === 'dark'
            ? theme.palette.custom.darkBlue2
            : theme.palette.custom.white,
      borderRadius: 20,

      color: props.color === 'light' ? theme.palette.custom.darkBlue2 : undefined,
      fontWeight: FONTS.WEIGHTS.bold,
      textTransform: 'none',
      lineHeight: 1.25,

      '&:hover, &:focus': {
        backgroundColor:
          props.color === 'primary'
            ? undefined
            : props.color === 'dark'
              ? theme.palette.custom.black
              : theme.palette.custom.grey,
      },

      [theme.breakpoints.down('tablet')]: {
        padding: '0 20px',

        fontSize: FONTS.SIZES.s,
      },

      [theme.breakpoints.down('mobile_l')]: {
        padding: '0 8px',

        // fontSize: FONTS.SIZES.xs,
      },

      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.m,
      },
    },
  }),
}))
